import { render, staticRenderFns } from "./TypeAnswerQuizInput.vue?vue&type=template&id=61991fe8&"
import script from "./TypeAnswerQuizInput.vue?vue&type=script&lang=js&"
export * from "./TypeAnswerQuizInput.vue?vue&type=script&lang=js&"
import style0 from "./TypeAnswerQuizInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports